import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import { UpsertFolderSharingsRequest, UpsertFolderSharingsResponse } from "@maven-rest/docs/FolderSharing.dto";
import { FolderSharingUrl } from "@maven-rest/docs/FolderSharing.url";

export function useUpsertFolderSharingsMutation(
  options?: SimpleMutationOptions<UpsertFolderSharingsResponse, UpsertFolderSharingsRequest>
) {
  return useBaseMutation({
    fnOption: { url: FolderSharingUrl.upsertFolderSharings },
    ...options,
  });
}
